import React from 'react';
import NoImage from '../../../../images/no-image.png';
import T from 'i18n-react';
import Link from '@material-ui/core/Link';
import Card from './components/Card';
import CardActionArea from './components/CardActionArea';
import CardMedia from './components/CardMedia';
import CardContent from './components/CardContent';
import Image from './components/Image';
import Small from './components/Small';
import Name from './components/Name';
import Review from './components/Review';
import Subcategory from './components/Subcategory';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import RenderLazyLoad from '../../components/LazyLoad/RenderLazyLoad';
import Title from './components/Title';
import New from './components/New';

export type BusinessCardProps = {
  isRecent: boolean,
  name: string,
  address: string,
  subcategory: string | null,
  title: string | null,
  url: string | null,
  imageUrl: string | null,
  onClick?: React.MouseEventHandler,
  mediaButton?: React.ReactNode,
  className?: string,
  review?: {
    averageRating?: string | null,
    totalCount?: number | null,
  },
};

const NoWrap: React.FC<TypographyProps> = withStyles({
  root: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
})(Typography);

const BusinessCard = ({
  isRecent,
  name,
  address,
  subcategory,
  title,
  imageUrl,
  url,
  className,
  onClick,
  review,
  mediaButton,
}: BusinessCardProps) => {
  const handleClick = (event) => {
    if (event.currentTarget?.contains(event.target)) {
      onClick?.(event);
    }
  };
  const averageRating = review
    ? Math.floor(review.averageRating * 10) / 10
    : null;

  return (
    <Card className={className}>
      <CardActionArea
        disableRipple={!url}
        disableTouchRipple={!url}
        {...(!!url && { href: url })}
        component={url ? Link : 'div'}
        onClick={handleClick}
      >
        <CardMedia alt={name} title={name}>
          <RenderLazyLoad
            observerOptions={{ rootMargin: '200px' }}
            render={({ isVisible }) => (
              <Image
                isVisible={isVisible}
                src={imageUrl || NoImage}
                alt="business card"
                loaded
                variant="rounded"
                className="media-image"
                disableFallback
              />
            )}
          />
          {mediaButton}
        </CardMedia>
        <CardContent>
          <NoWrap component="div" gutterBottom color="textPrimary">
            {review != null && (
              <Review
                color="textPrimary"
                display="inline"
                rating={averageRating}
                totalCount={review.totalCount.toLocaleString()}
              />
            )}
            <Subcategory
              component="span"
              label={subcategory || T.translate('other')}
              size="small"
            />
          </NoWrap>
          <Name color="textPrimary" className="text-break-all" gutterBottom>
            {isRecent && <New />}
            {name}
          </Name>
          <Small
            className="line-truncate-1 text-break-all"
            gutterBottom
            color="primary"
          >
            {address}
          </Small>
          <Title color="textSecondary">{title}</Title>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default BusinessCard;
